module.exports = __webpack_public_path__ + "img/Republic of the Congo.6d210bfd.svg";